<template>
	<div class="now-playing" :style="{ backgroundImage: playing.artwork !== null ? `url('${secureArtwork(playing.artwork)}')` : `` }" v-if="playing != null">
		<div class="container">
			<div class="artwork" v-if="playing.artwork !== null">
				<img :src="playing.artwork | secure" :alt="playing.track"/>
			</div>
			<div class="track-info">
				<h1 class="artist">{{ playing.artist }}</h1>
				<h2 class="track">{{ playing.track }}</h2>
				<h3 v-if="playing.game" class="game">{{ playing.game }}</h3>
			</div>
			<div class="track-stats" v-if="playing.stats && playing.stats.hasOwnProperty('is_new')" :class="{ 'no-artwork': !playing.artwork }">
				<span v-if="playing.stats.is_new === true" class="plays tag is-primary is-medium is-new-track">New</span>
				<span class="info"><a :href="`https://last.fm/music/${playing.artist}/_/${playing.track}`" target="_blank"><span class="fa fa-lastfm"></span>Purchase on last.fm</a></span>
				
				<template v-if="playing.stats && playing.stats.is_new !== true">
					<span class="bull">&bull;</span>
					<span class="plays">{{ playing.stats.play_count + ` play` + (playing.stats.play_count == 1 ? `` : `s`) }}</span>
					<span class="bull">&bull;</span>
					<span class="last-played">{{ `Last played: ` + getLastPlayedDate(playing.stats.last_played) }}</span>
				</template>
			</div>
		</div>
	</div>
	<div v-else class="now-playing loading">
	</div>
</template>

<script>
	export default {
		name: 'nowplaying',
		data () {
			return {
			}
		},

		props: {
			playing: Object
		},

		watch: {
			playing: {
				deep: true,
				handler (val) {
					this.$winapp.updateMediaControls(val.artist, val.track, this.secureArtwork(val.artwork));
				}
			}
		},

		filters: {
			secure (val) {
				if (val === null) return "//placehold.it/300x300?text=MR";
				return val.replace("http:", "https:");
			}
		},

		methods: {
			getLastPlayedDate (timestamp) {
				timestamp = timestamp *= 1000;
				var dateObj = new Date(timestamp);

				var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

				return dateObj.getDate() + this.getDateSuffix(dateObj.getDate()) + ' ' + months[dateObj.getMonth()] + ' ' + dateObj.getFullYear();
			},

			getDateSuffix (number) {
				switch (number) {
					case 1:
					case 21:
					case 31:
						return 'st';

					case 2:
					case 22:
						return 'nd';

					case 3:
					case 23:
						return 'rd';
				}

				return 'th';
			},


			secureArtwork (val) {
				if (val === null) return "//placehold.it/300x300?text=MR";
				return val.replace("http:", "https:");
			}
		}
	}
</script>

<style lang="scss" scoped>
	$now-playing-height: 250px;
	$now-playing-artwork-size: 150px;

	.now-playing {
		&:before {
			background: rgba(0, 0, 0, 0.5);
			bottom: 0;
			content: " ";
			left: 0;
			position: absolute;
			right: 0;
			top: 0;
		}

		align-items: center;
		background: #AAA;
		background-attachment: fixed;
		background-position: center;
		background-size: cover;		
		clear: both;
		display: flex;
		float: left;
		justify-content: center;
		height: $now-playing-height;
		padding: 30px 0;
		position: relative;
		width: 100%;

		&.loading {
			height: auto;
		}
	}

	.artwork {
		display: inline-block;
		float: left;

		img {
			border: 1px solid $default-border-col;
			display: block;
			height: $now-playing-artwork-size;
			width: $now-playing-artwork-size;
		}
	}

	.track-info {
		color: #FFF;
		display: inline-block;
		float: left;
		height: calc(#{$now-playing-artwork-size} - 1.4rem);
		padding-bottom: 30px;
		padding-left: 30px;
		width: calc(100% - #{$now-playing-artwork-size});

		.artist,
		.track,
		.game {
			clear: both;
			display: inline-block;
			float: left;
			margin-bottom: 5px;
			text-align: left;

			&:last-child {
				margin-bottom: 0;
			}
		}

		.artist {
			font-size: 1.5rem;
			font-weight: bold;
		}

		.track {
			font-size: 1.2rem;
			margin-bottom: 10px;
		}

		.game {
			font-size: 1rem;
			font-style: italic;
		}
	}

	.track-stats {
		align-items: center;
		color: #FFF;
		display: flex;
		font-size: .85rem;
		height: 100%;
		padding-left: 30px;

		&.no-artwork {
			width: 100%;
		}

		a {
			&,
			&:link,
			&:visited {
				color: #FFF;
				text-decoration: underline;
			}
		}

		.fa:before {
			color: #FFF;
			line-height: 1.3rem;
		}

		.fa {
			color: #FFF;
			margin: 0 5px;
		}

		.info .fa {
			margin-left: 0;
		}

		.is-new-track {
			height: auto;
			margin-right: 10px;
			padding: 0 10px;
		}
		
		.bull {
			padding: 0 5px;
		}
	}	
</style>



// WEBPACK FOOTER //
// NowPlaying.vue?84040f46